import { defaultAnchorSpec, type AnchorSpec } from '@ar-suite/core'
import type { ProceduralGlassesOptions } from './procedural'

/** Built-in demo products (procedural — no GLB download needed). */
export interface ProceduralProduct {
  id: string
  name: string
  procedural: Partial<ProceduralGlassesOptions>
  anchor: AnchorSpec
}

function spec(patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec('glasses')
  // procedural frames: origin at the bridge; sit slightly forward of the nose-bridge skin, a touch lower
  s.offset = [0, -0.4, 1.0]
  s.unitScale = 1 // already in cm
  s.glasses = { ...s.glasses, autoFitTemples: true, lensOpacity: 0.18 }
  return Object.assign(s, patch)
}

export const PROCEDURAL_PRODUCTS: ProceduralProduct[] = [
  {
    id: 'proc-square-black',
    name: 'Square · Black acetate',
    procedural: { style: 'square', color: 0x151515, material: 'acetate', lensTint: 0x88aacc, lensOpacity: 0.18 },
    anchor: spec(),
  },
  {
    id: 'proc-round-gold',
    name: 'Round · Gold metal',
    procedural: { style: 'round', color: 0xd4a94a, material: 'metal', lensWidth: 4.6, lensHeight: 4.4, bridgeWidth: 2.0, lensTint: 0x88aacc, lensOpacity: 0.15 },
    anchor: spec(),
  },
  {
    id: 'proc-aviator-sun',
    name: 'Aviator · Sunglasses',
    procedural: { style: 'aviator', color: 0xb8b8c0, material: 'metal', lensWidth: 5.6, lensHeight: 4.8, bridgeWidth: 1.6, lensTint: 0x2a1a0a, lensOpacity: 0.78 },
    anchor: spec({ glasses: { autoFitTemples: true, lensOpacity: 0.78, lensTint: '#2a1a0a' } }),
  },
  {
    id: 'proc-cateye-red',
    name: 'Cat-eye · Red',
    procedural: { style: 'cateye', color: 0x8b1e2d, material: 'acetate', lensWidth: 5.2, lensHeight: 3.6, lensTint: 0x88aacc, lensOpacity: 0.18 },
    anchor: spec(),
  },
]
